import { render, staticRenderFns } from "./TextToggle.vue?vue&type=template&id=68c016ef&scoped=true&"
import script from "./TextToggle.vue?vue&type=script&lang=js&"
export * from "./TextToggle.vue?vue&type=script&lang=js&"
import style0 from "./TextToggle.vue?vue&type=style&index=0&id=68c016ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c016ef",
  null
  
)

export default component.exports